import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const useNotifications = (onOpenRide, enabled) => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const seen = useRef(null);
  const openRef = useRef(onOpenRide);
  openRef.current = onOpenRide;

  const load = useCallback(async () => {
    try {
      const { data: res } = await api.get("/notifications");
      if (seen.current) {
        res.items.filter((n) => !n.read && !seen.current.has(n.id)).forEach((n) => {
          toast(n.title, { description: n.body, action: n.share_code ? { label: "Apri", onClick: () => openRef.current(n.share_code) } : undefined });
        });
      }
      seen.current = new Set(res.items.map((n) => n.id));
      setData(res);
    } catch {
      /* polling retry */
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      seen.current = null;
      setData({ items: [], unread: 0 });
      return undefined;
    }
    load();
    const i = setInterval(load, 20000);
    return () => clearInterval(i);
  }, [load, enabled]);

  const markAllRead = async () => {
    await api.post("/notifications/read-all").catch(() => {});
    load();
  };

  return { ...data, reload: load, markAllRead };
};
